import Banyan1 from '../Tipe 10/Tipe 10 (1).webp'
import Banyan2 from '../Tipe 10/Tipe 10 (2).webp'
import Banyan3 from '../Tipe 10/Tipe 10 (3).webp'
import Banyan4 from '../Tipe 10/Tipe 10 (4).webp'
import Banyan5 from '../Tipe 10/Tipe 10 (5).webp'
import Banyan6 from '../Tipe 10/Tipe 10 (6).webp'
import Banyan7 from '../Tipe 10/Tipe 10 (7).webp'
import Banyan8 from '../Tipe 10/Tipe 10 (8).webp'
import Banyan9 from '../Tipe 10/Tipe 10 (9).webp'
import Banyan10 from '../Tipe 10/Tipe 10 (10).webp'
import Banyan11 from '../Tipe 10/Tipe 10 (11).webp'
import Banyan12 from '../Tipe 10/Tipe 10 (12).webp'
import Banyan13 from '../Tipe 10/Tipe 10 (13).png'


const Banyanimages =[
Banyan1,Banyan2,Banyan3,Banyan4,Banyan5,Banyan6,Banyan7,Banyan8,Banyan9,Banyan10,Banyan11,Banyan12,Banyan13
]

export default Banyanimages;